import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { Message, ChatSession } from '@shared/types'

interface ChatState {
  sessions: Record<string, ChatSession>
  activeSessionId: string | null
  isTyping: boolean
}

const initialState: ChatState = {
  sessions: {},
  activeSessionId: null,
  isTyping: false,
}

const chatSlice = createSlice({
  name: 'chat',
  initialState,
  reducers: {
    createSession: (state, action: PayloadAction<{ sessionId: string; agentType: 'hr' | 'ops' }>) => {
      const { sessionId, agentType } = action.payload
      state.sessions[sessionId] = {
        id: sessionId,
        agentType,
        messages: [],
        isLoading: false,
        error: null,
      }
      state.activeSessionId = sessionId
    },
    setActiveSession: (state, action: PayloadAction<string>) => {
      state.activeSessionId = action.payload
    },
    addMessage: (state, action: PayloadAction<{ sessionId: string; message: Message }>) => {
      const { sessionId, message } = action.payload
      if (state.sessions[sessionId]) {
        state.sessions[sessionId].messages.push(message)
      }
    },
    setLoading: (state, action: PayloadAction<{ sessionId: string; isLoading: boolean }>) => {
      const { sessionId, isLoading } = action.payload
      if (state.sessions[sessionId]) {
        state.sessions[sessionId].isLoading = isLoading
      }
    },
    setError: (state, action: PayloadAction<{ sessionId: string; error: string | null }>) => {
      const { sessionId, error } = action.payload
      if (state.sessions[sessionId]) {
        state.sessions[sessionId].error = error
      }
    },
    setTyping: (state, action: PayloadAction<boolean>) => {
      state.isTyping = action.payload
    },
    clearSession: (state, action: PayloadAction<string>) => {
      const sessionId = action.payload
      if (state.sessions[sessionId]) {
        state.sessions[sessionId].messages = []
        state.sessions[sessionId].error = null
      }
    },
  },
})

export const {
  createSession,
  setActiveSession,
  addMessage,
  setLoading,
  setError,
  setTyping,
  clearSession,
} = chatSlice.actions

export default chatSlice.reducer 